import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "plan-content overflow-auto" }
const _hoisted_2 = { class: "account-actions pdt-0 sm-pdb-0" }
const _hoisted_3 = { class: "action-buttons justify-content-end sm-pdb-10 sm-pdl-0 sm-pdr-0" }
const _hoisted_4 = { class: "bordered-card" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "iatse-icon-info-circle-solid icon_rotate_0 icon_danger icon-tooltip icon-tooltip_tertiary fs-lg" }
const _hoisted_8 = { class: "tooltip-text" }
const _hoisted_9 = {
  key: 1,
  class: "col-md-12 text-center my-4"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("span", null, " Currently there are no dependents on file ", -1)
const _hoisted_11 = [
  _hoisted_10
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_MessageCard = _resolveComponent("MessageCard")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return ($setup.loading)
    ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
        _createVNode(_component_MessageCard, {
          message: "The displayed information is from your records with the Fund Office. If the information is not correct, click on the applicable dependent in order to update. If you wish to add a new dependent, click the button on the upper right side of your screen.",
          type: "primary",
          iconClass: "iatse-icon-alarm",
          classes: "info_card_full"
        }),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("a", {
                href: "",
                class: "btn btn-secondary plan-modal",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => ($setup.openModal('add-beneficiary',
                        'My Beneficiary(ies)',
                        'plan-tables-striped beneficiary',
                        null,
                        null,
                        null,
                    )), ["prevent"]))
              }, " View Beneficiary(ies) "),
              _createElementVNode("a", {
                href: "",
                class: "btn btn-primary plan-modal",
                onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => ($setup.handleAdd && $setup.handleAdd(...args)), ["prevent"]))
              }, " Add Dependent ")
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            ($setup.dependents.rows?.length)
              ? (_openBlock(), _createBlock(_component_DataTable, {
                  key: 0,
                  table: $setup.dependents,
                  "has-actions": true,
                  hasInfo: true,
                  classes: "striped small equal-headings"
                }, {
                  actions: _withCtx(({ entity }) => [
                    (entity.CanEdit)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 0,
                          class: _normalizeClass(["iatse-icon-edit plan-modal", { 'disabled-icon': !entity.CanEdit }]),
                          onClick: ($event: any) => ($setup.handleEdit(entity))
                        }, null, 10, _hoisted_5))
                      : _createCommentVNode("", true),
                    (entity.CanDelete)
                      ? (_openBlock(), _createElementBlock("i", {
                          key: 1,
                          class: _normalizeClass(["iatse-icon-trash plan-modal", { 'disabled-icon': !entity.CanDelete }]),
                          onClick: ($event: any) => ($setup.handleDelete(entity))
                        }, null, 10, _hoisted_6))
                      : _createCommentVNode("", true)
                  ]),
                  info: _withCtx(({ info }) => [
                    _createElementVNode("i", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(info), 1)
                    ])
                  ]),
                  _: 1
                }, 8, ["table"]))
              : ($setup.dependents?.rows.length === 0 || !$setup.dependents)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
                : _createCommentVNode("", true)
          ])
        ])
      ], 64))
}